import { render, staticRenderFns } from "./AddOrdersMenu.vue?vue&type=template&id=9a981382"
import script from "./AddOrdersMenu.vue?vue&type=script&lang=js"
export * from "./AddOrdersMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports